import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { HideableNodeType } from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';

interface Props {
  nodeType: HideableNodeType;
  icon: string;
  onClick: (nodeType: HideableNodeType) => void;
  visible: boolean;
}

const BareTopologyLayoutSettingsToggleableNodeType: FC<Props> = (props) => {
  const msg = useLocale();

  const handleClick = () => {
    props.onClick(props.nodeType);
  };

  return (
    <span
      className='graph-layout-settings-devices__device mb-lgu-3 inline-flex cursor-pointer items-center'
      onClick={handleClick}
    >
      <div className='graph-layout-settings-devices__device-icon'>
        <img
          draggable={false}
          src={props.icon}
          alt={
            msg.canvasGraph.graphSidePanel.layoutSettings.hideableNodeTypes
              .labels[props.nodeType]
          }
          className='size-full'
        />
      </div>
      <span className='ml-lgu-3 inline-block flex-1'>
        {
          msg.canvasGraph.graphSidePanel.layoutSettings.hideableNodeTypes
            .labels[props.nodeType]
        }
      </span>
      <Tooltip
        content={
          msg.canvasGraph.graphSidePanel.layoutSettings.hideableNodeTypes[
            props.visible ? 'hideNodeType' : 'showNodeType'
          ]
        }
      >
        <Button
          variant='tertiary'
          size='xxxs'
          icon={props.visible ? 'fa-eye' : 'fa-eye-slash'}
          className='ml-2'
          type='button'
        />
      </Tooltip>
    </span>
  );
};

export const TopologyLayoutSettingsToggleableNodeType = memo(
  BareTopologyLayoutSettingsToggleableNodeType,
);
